<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="display"
    :items="studentList"
    return-object
    @change="onChange"
    :search-input.sync="inputValue"
    clearable
    :loading="loading"
    v-model="student"
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <CardStudentExamInfo :student="data.item" />
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import api from '../../../plugins/api'
import { debounce, orderBy } from 'lodash'
import utils from '@/plugins/utils.js'
import { StudentExam } from '@/plugins/api'
import CardStudentExamInfo from '@/components/basic/card/CardStudentExamInfo.vue'
import { textHelpers } from '@/helpers/TextHelper'
import { mapGetters } from 'vuex'

export default {
  components: {
    CardStudentExamInfo
  },
  data: () => ({
    students: [],
    inputValue: '',
    loading: false,
    student: ''
  }),
  props: {
    filter: Object,
    options: Object,
    defaultStudent: Object,
    syncedValue: Object,
    exam: String
  },
  watch: {
    async inputValue(search) {
      this.debounce(search, this)
    },
    filter(filter) {
      this.inputValue = null
      this.fetchStudents(filter)
    },
    syncedValue(value) {
      this.student = value
    }
  },
  methods: {
    async fetchStudents() {
      this.loading = true
      const params = {
        _sort: 'examCode:ASC',
        exam: this.exam
      }

      this.students = await StudentExam.fetch(params)

      this.loading = false
    },
    onChange(data) {
      this.$emit('update:syncedValue', data)
      this.$emit('change', data)
      this.$emit('input', data)
    },
    debounce: debounce(async (search, context) => {
      if (!search || context.student) {
        await context.fetchStudents()
        return
      }

      // this.loading = true
      let params = {
        exam: this.exam
      }

      const data = await api.StudentExam.search({
        ...params,
        tags_contains: textHelpers.removeSpaces(utils.clearUnicode(search)),
        _limit: 5,
        _sort: 'examCode:ASC'
      })
      // this.loading = false
      context.students = data
    }, 150)
  },

  computed: {
    ...mapGetters('auth', ['ownClassIds']),
    studentList() {
      const students = orderBy(this.students, ['examCode'], ['asc'])
      return [...students, this.defaultStudent]
        .filter(u => !!u && !!u.examCode)
        .map(s => ({ ...s, display: `${s.student.name} [${s.examCode}]` }))
    }
  }
}
</script>
